/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreNotification = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 12 16"
  >
    <path
      d="M3.557 13.25c.246 1.111 1.283 2 2.444 2s2.198-.889 2.444-2H3.557zm7.814-1.836l-.87-.957V6.75c0-2.21-1.604-4.043-3.708-4.42a.971.971 0 0 0 .208-.58 1 1 0 1 0-2 0c0 .221.086.415.207.58-2.103.377-3.707 2.21-3.707 4.42v3.707l-.87.957a.5.5 0 0 0 .37.836h10a.5.5 0 0 0 .37-.836z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);

IconCoreNotification.displayName = 'IconCoreNotification';

IconCoreNotification.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreNotification);
IconCoreNotification.displayName = 'IconCoreNotification';
